import type { EmailBlock } from '../HtmlEditor.types';

type InlineFormatBarProps = {
  block: EmailBlock;
  onChange?: (patch: Partial<EmailBlock>) => void;
  disabled?: boolean;
};

export function InlineFormatBar({ block, onChange, disabled }: InlineFormatBarProps) {
  const font = 'font' in block ? block.font : 'Arial';
  const size = 'size' in block ? block.size : 14;
  const color = 'color' in block ? block.color : '#0F172A';

  return (
    <div className='ee-inlinebar' onClick={(e) => e.stopPropagation()}>
      <select className='ee-inlinebar__select' defaultValue='paragraph' style={{ width: 120 }} disabled={disabled}>
        <option>Paragraph</option>
        <option>Heading 1</option>
        <option>Heading 2</option>
        <option>Heading 3</option>
      </select>
      <select
        className='ee-inlinebar__select'
        value={font}
        style={{ width: 110 }}
        disabled={disabled}
        onChange={(e) => onChange?.({ font: e.target.value } as Partial<EmailBlock>)}
      >
        <option>Arial</option>
        <option>Helvetica</option>
        <option>Georgia</option>
        <option>Verdana</option>
        <option>Times New Roman</option>
      </select>
      <input
        className='ee-inlinebar__num'
        type='number'
        value={size}
        disabled={disabled}
        onChange={(e) => onChange?.({ size: +e.target.value } as Partial<EmailBlock>)}
      />
      <label className='ee-inlinebar__color' style={{ background: color }} title='Text color'>
        <input
          type='color'
          value={color}
          disabled={disabled}
          onChange={(e) => onChange?.({ color: e.target.value } as Partial<EmailBlock>)}
          style={{ opacity: 0, width: '100%', height: '100%', cursor: 'pointer' }}
        />
      </label>
      <span className='ee-inlinebar__sep' />
      <button type='button' title='Bold' style={{ fontWeight: 800 }} disabled={disabled}>
        B
      </button>
      <button type='button' title='Italic' style={{ fontStyle: 'italic' }} disabled={disabled}>
        I
      </button>
      <button type='button' title='Underline' style={{ textDecoration: 'underline' }} disabled={disabled}>
        U
      </button>
      <button type='button' title='Strike' style={{ textDecoration: 'line-through' }} disabled={disabled}>
        S
      </button>
      <span className='ee-inlinebar__sep' />
      <button type='button' title='Link' disabled={disabled}>
        🔗
      </button>
      <button type='button' title='Code' disabled={disabled}>
        {'<>'}
      </button>
      <button type='button' title='Emoji' disabled={disabled}>
        😊
      </button>
      <button type='button' title='Variable' disabled={disabled}>
        {'{ }'}
      </button>
      <span className='ee-inlinebar__sep' />
      <button type='button' title='Bulleted list' disabled={disabled}>
        •≡
      </button>
      <button type='button' title='Numbered list' disabled={disabled}>
        1.≡
      </button>
      <span className='ee-inlinebar__sep' />
      <button type='button' title='Align left' disabled={disabled}>
        ⇤
      </button>
      <button type='button' title='Align center' disabled={disabled}>
        ⇔
      </button>
      <button type='button' title='Align right' disabled={disabled}>
        ⇥
      </button>
    </div>
  );
}
